import { c as _c } from "react/compiler-runtime";
import { MAX_IMAGE_SIZE_MB, MAX_VIDEO_SIZE_MB } from '@/constants/file';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';
type MessageType = 'unsupported-file-type-1' | 'unsupported-file-type-2' | 'image-dimensions-too-large' | 'profile-media-file-too-large' | 'profile-avatar-file-too-large' | 'profile-banner-file-too-large' | 'connection-issue';
type UploadError = {
  title: string;
  description: string;
};
type UploadErrorMessages = Record<MessageType, UploadError>;
export const useUploadErrorMessages = () => {
  const $ = _c(57);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("upload-errors.unsupported-file-type.title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("upload-errors.unsupported-file-type-1.description");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      title: t0,
      description: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("upload-errors.unsupported-file-type.title");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("upload-errors.unsupported-file-type-2.description");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = {
      title: t3,
      description: t4
    };
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t("upload-errors.image-dimensions-too-large.title");
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t("upload-errors.image-dimensions-too-large.description");
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = {
      title: t6,
      description: t7
    };
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t) {
    t9 = t("upload-errors.file-too-large.title");
    $[21] = t;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t) {
    t10 = t("upload-errors.profile-media-file-too-large.description", {
      videoSize: MAX_VIDEO_SIZE_MB,
      imageSize: MAX_IMAGE_SIZE_MB
    });
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t9) {
    t11 = {
      title: t9,
      description: t10
    };
    $[25] = t10;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t) {
    t12 = t("upload-errors.file-too-large.title");
    $[28] = t;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t) {
    t13 = t("upload-errors.profile-avatar-file-too-large.description", {
      imageSize: MAX_IMAGE_SIZE_MB
    });
    $[30] = t;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t12 || $[33] !== t13) {
    t14 = {
      title: t12,
      description: t13
    };
    $[32] = t12;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t) {
    t15 = t("upload-errors.file-too-large.title");
    $[35] = t;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t) {
    t16 = t("upload-errors.profile-banner-file-too-large.description", {
      imageSize: MAX_IMAGE_SIZE_MB
    });
    $[37] = t;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t15 || $[40] !== t16) {
    t17 = {
      title: t15,
      description: t16
    };
    $[39] = t15;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t) {
    t18 = t("upload-errors.connection-issue.title");
    $[42] = t;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t) {
    t19 = t("upload-errors.connection-issue.description");
    $[44] = t;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t18 || $[47] !== t19) {
    t20 = {
      title: t18,
      description: t19
    };
    $[46] = t18;
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t11 || $[50] !== t14 || $[51] !== t17 || $[52] !== t2 || $[53] !== t20 || $[54] !== t5 || $[55] !== t8) {
    t21 = {
      "unsupported-file-type-1": t2,
      "unsupported-file-type-2": t5,
      "image-dimensions-too-large": t8,
      "profile-media-file-too-large": t11,
      "profile-avatar-file-too-large": t14,
      "profile-banner-file-too-large": t17,
      "connection-issue": t20
    };
    $[49] = t11;
    $[50] = t14;
    $[51] = t17;
    $[52] = t2;
    $[53] = t20;
    $[54] = t5;
    $[55] = t8;
    $[56] = t21;
  } else {
    t21 = $[56];
  }
  const uploadErrors = t21;
  return uploadErrors;
};